const REDUCER = "@PROFILE/";

const actions = {
  GET_CURRENT_PROFILE: `${REDUCER}GET_CURRENT_PROFILE`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_PROFILE: `${REDUCER}SET_CURRENT_PROFILE`,
};
export default actions;
